<template>
  <ppt-slide-viewer module-code="cq_jm" />
</template>

<script>
import PptSlideViewer from "@/components/PptSlideViewer.vue";

export default {
  name: "CqJm",
  components: { PptSlideViewer }
};
</script>
